import { Icon } from "@vds/icons";
import { Tooltip } from "antd";
import "./Tags.css";
import { NON_REMOVABLE_TAGS, LOCATION_TAG_TYPES, TAG_TYPES } from "./TagsConstants";

const TagsInput = ({ TagList, handleCloseIconClickFromTag, getTagTitle }) => {
  const getCrossIconToFilterItems = (filterText) => {
    if (NON_REMOVABLE_TAGS.includes(filterText)) {
      return (<></>);
    } else {
      return (<span className="tag-close-icon" id={filterText} onClick={handleCloseIconClickFromTag}>{" "}
        <Icon name="close" size="small" id={filterText} /></span>);
    }
  }
  return (
    <div className="tags-input-container">
      {Object.keys(TagList).map((tag) => {
        if (TagList[tag]?.length > 0) {
          if (tag === LOCATION_TAG_TYPES.FLOOR || tag === LOCATION_TAG_TYPES.AREA || tag === LOCATION_TAG_TYPES.SUBAREA) {
            return (<div className="tag-item" key={tag}>
              <span className="text">
                {TagList[tag].length > 0 &&
                  <ul className="tag-item-list">
                    {TagList[tag].map((item, index) => {
                      const title = getTagTitle?.(tag, item, index);
                      const listItem = (
                        <li className="tag-item-list-item" key={index}>{item}
                          <span className="tag-close-icon" id={tag + ":" + item} onClick={handleCloseIconClickFromTag}>
                            <Icon name="close" size="small" id={tag + ":" + item} />
                          </span>
                        </li>
                      );
                      return title ? <Tooltip key={index} title={title}>{listItem}</Tooltip> : listItem;
                    })}
                  </ul>}
              </span>
            </div>)
          }
          else if (tag === TAG_TYPES.OBJECT) {
            return (
              <div className="tag-item" key={tag}>
                <span className="text">{TagList[tag]}</span>
                <span className="tag-close-icon" id={TAG_TYPES.OBJECT + ":" + TagList[tag]} onClick={handleCloseIconClickFromTag}>
                  <Icon name="close" size="small" id={TAG_TYPES.OBJECT + ":" + TagList[tag]} />
                </span>
              </div>
            );
          }
          else {
            return (<div className="tag-item" key={tag}>
              <span className="text">{TagList[tag].length > 1 ? TagList[tag] + " " : TagList[tag]}</span>
              {getCrossIconToFilterItems(tag)}
            </div>)
          }

        }
      })}
    </div>
  )
};
export default TagsInput;